import { Hint } from 'components';
import { ListTypography, Stack, Typography } from 'libs/ui';

import { HintTitleStyled } from './FieldLabelWithHint.styles';

type Props = {
  hintTitle?: string;
  hintTexts: string[];
  label?: string;
};

export const FieldLabelWithHint = ({ hintTitle, hintTexts, label }: Props) => (
  <Stack alignItems="center" direction="row" spacing={8}>
    {label}
    <Hint
      title={
        <HintTitleStyled spacing={4}>
          <Typography variant="bodyBold">{hintTitle}</Typography>
          <ListTypography
            listType="ul"
            spacing={4}
            texts={hintTexts}
            variant="caption"
          />
        </HintTitleStyled>
      }
    />
  </Stack>
);
